export default function NotFound() {
    return (
        <section>
            <h1>404 Not Found</h1>
            <p>YEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEET</p>
        </section>
    )
}